import { render, staticRenderFns } from "./CurrentFileTab.vue?vue&type=template&id=891945d6&scoped=true"
import script from "./CurrentFileTab.vue?vue&type=script&lang=ts"
export * from "./CurrentFileTab.vue?vue&type=script&lang=ts"
import style0 from "./CurrentFileTab.vue?vue&type=style&index=0&id=891945d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891945d6",
  null
  
)

export default component.exports